import { QuestionDataSourceType as LS360QuestionDataSourceType, QUESTION_SCENE_TYPE } from '@patsnap/ls360_sdk_feature'
import { ILang } from '@patsnap/synapse_common_interface'
import { sharedCtx } from '@pharmsnap/shared/src/context'

export type QuestionDataSourceType = LS360QuestionDataSourceType | 'epidemiology'

const sceneType2DataSourceMap: Record<string, QuestionDataSourceType> = {
  LLM_DEMO_QUESTION_ALL: 'all',
  LLM_DEMO_QUESTION_PATENT: 'patent',
  LLM_DEMO_QUESTION_PAPER: 'paper',
  LLM_DEMO_QUESTION_CT: 'clinical_trials',
  LLM_DEMO_QUESTION_FDA: 'fda_label',
  LLM_DEMO_QUESTION_FINANCIAL: 'financial_report',
  LLM_DEMO_QUESTION_CT_GUIDE: 'clinical_guideline',
  LLM_DEMO_QUESTION_EPI: 'epidemiology',
}

const sceneTypeList = [...QUESTION_SCENE_TYPE, 'LLM_DEMO_QUESTION_EPI']

export async function getLS360QuestionExamples(locale: ILang = 'EN'): Promise<Array<{ question: string; dataSource: QuestionDataSourceType }>> {
  const res = await sharedCtx.service.tag.getLS360HotTags({ scene_type: sceneTypeList })

  if (res.success) {
    const questionExamples = sceneTypeList.reduce<Array<{ question: string; dataSource: QuestionDataSourceType }>>((acc, scene) => {
      // 提取前3条
      const currentSceneExamples = res.data?.hot_tag_map[scene]
        ?.filter((example) => example.content_language === locale)
        ?.sort((a, b) => (b.rnk || 0) - (a.rnk || 0))
        ?.slice(0, 3)

      if (currentSceneExamples) {
        return acc.concat(
          currentSceneExamples.map((example) => ({
            question: example.display_name_en,
            dataSource: sceneType2DataSourceMap[scene],
          }))
        )
      }
      return acc
    }, [] as Array<{ question: string; dataSource: QuestionDataSourceType }>)

    return questionExamples
  }
  return []
}
